import React from "react";
import LoginForm from "../components/loginForm";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

function LoginPage() {
  return (
    <>
      <Navbar />
      <LoginForm />
      <Footer />
    </>
  );
}

export default LoginPage;
